function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import concat from 'ramda/src/concat';
import forEachObjIndexed from 'ramda/src/forEachObjIndexed';
import groupBy from 'ramda/src/groupBy';
import uniqBy from 'ramda/src/uniqBy';
import mergeDeepWith from 'ramda/src/mergeDeepWith';
import pathOr from 'ramda/src/pathOr';
import { BILLER_RULE_INSTANCE_TYPE, BILLER_RULE_INSTANCE_TYPE_COMBINATIONS } from '../../../../../customercare.constants';
import { PRODUCT_CLASSIFICATIONS } from 'invision-core/src/constants/product.constants';
import { OFFERING_OPTION_STATUSES } from '../../../../../components/shared/constants/offering.option.status.constants';
import { BRI_ACTIVATION_STATUS } from 'invision-core/src/constants/pricing.plan.constants';
var getOptionBillerItemBulkPricesByType = function getOptionBillerItemBulkPricesByType(option) {
  return groupBy(function (billerItemBulkPrice) {
    return billerItemBulkPrice.Type;
  }, option.BillerRulePrices || []);
};
export function filterBulkOfferOptions(offer) {
  return pathOr([], ['Options'], offer).filter(function (option) {
    return option.BillerRulePrices && option.BillerRulePrices.length > 0 && option.OfferingId === offer.OfferingId;
  });
}
export function hasBulkOfferOptions(offer) {
  var bulkOfferOptions = filterBulkOfferOptions(offer);
  return bulkOfferOptions.length > 0 ? true : false;
}
var getOptionBillerTypeAmountsByType = function getOptionBillerTypeAmountsByType(option) {
  return groupBy(function (billerTypeAmount) {
    return billerTypeAmount.Type;
  }, option.BillerTypeAmounts || []);
};
export var getOfferOptionsWithInactiveBrisRemoved = function getOfferOptionsWithInactiveBrisRemoved(offer, type) {
  var serviceFeatures = pathOr([], ['ServiceFeatures'], offer);
  var path = type === PRODUCT_CLASSIFICATIONS.SERVICE_FEATURE ? serviceFeatures : [].concat(_toConsumableArray(pathOr([], ['Options'], offer)), _toConsumableArray(serviceFeatures));
  return path.map(function (option) {
    var activeBillerTypeAmounts = pathOr([], ['BillerTypeAmounts'], option).filter(function (billerTypeAmount) {
      return billerTypeAmount.Status === BRI_ACTIVATION_STATUS.ACTIVE && (billerTypeAmount.Type === BILLER_RULE_INSTANCE_TYPE.RECURRING || billerTypeAmount.Type === BILLER_RULE_INSTANCE_TYPE.ENTITLEMENT || billerTypeAmount.Type === BILLER_RULE_INSTANCE_TYPE.ONETIME) || billerTypeAmount.Type === BILLER_RULE_INSTANCE_TYPE.USAGE || billerTypeAmount.Type === BILLER_RULE_INSTANCE_TYPE.TRIGGER || billerTypeAmount.Type === BILLER_RULE_INSTANCE_TYPE.EARLY_TERMINATION_FEE || billerTypeAmount.Type === BILLER_RULE_INSTANCE_TYPE.CUSTOM || billerTypeAmount.Type === BILLER_RULE_INSTANCE_TYPE.SUBSCRIPTION;
    });
    var billerItemBulkPricesForActiveBillerTypeAmounts = pathOr([], ['BillerRulePrices'], option).filter(function (billerItemBulkPrice) {
      return !!activeBillerTypeAmounts.find(function (activeBillerTypeAmount) {
        return activeBillerTypeAmount.BillerRuleConfigurationId === billerItemBulkPrice.BillerRuleConfigurationId;
      });
    });
    return Object.assign({}, option, {
      BillerTypeAmounts: activeBillerTypeAmounts,
      BillerRulePrices: billerItemBulkPricesForActiveBillerTypeAmounts
    });
  });
};
export var getOptionBillerRulesGroupedByType = function getOptionBillerRulesGroupedByType(option) {
  return mergeDeepWith(concat, getOptionBillerItemBulkPricesByType(option), getOptionBillerTypeAmountsByType(option));
};

// NOTE: EBRIs may also have a related TBRI, but currently those can be effectively ignored for these scenarios
export var getOptionHasEntitlementBillerRuleOnly = function getOptionHasEntitlementBillerRuleOnly(billerRulesGroupedByType) {
  return !!(billerRulesGroupedByType[BILLER_RULE_INSTANCE_TYPE.ENTITLEMENT] && !billerRulesGroupedByType[BILLER_RULE_INSTANCE_TYPE.CUSTOM] && !billerRulesGroupedByType[BILLER_RULE_INSTANCE_TYPE.ONETIME] && !billerRulesGroupedByType[BILLER_RULE_INSTANCE_TYPE.RECURRING] && !billerRulesGroupedByType[BILLER_RULE_INSTANCE_TYPE.USAGE]);
};
export var getOptionHasUsageBillerRuleOnly = function getOptionHasUsageBillerRuleOnly(billerRulesGroupedByType) {
  return !!(billerRulesGroupedByType[BILLER_RULE_INSTANCE_TYPE.USAGE] && !billerRulesGroupedByType[BILLER_RULE_INSTANCE_TYPE.CUSTOM] &&
  //      !billerRulesGroupedByType[BILLER_RULE_INSTANCE_TYPE.ENTITLEMENT] &&
  !billerRulesGroupedByType[BILLER_RULE_INSTANCE_TYPE.ONETIME] && !billerRulesGroupedByType[BILLER_RULE_INSTANCE_TYPE.RECURRING]);
};
export function getOptionsByActiveBriType(offer, type) {
  var optionsByBriType = initializeBriOptionsObject();
  getOfferOptionsWithInactiveBrisRemoved(offer, type).forEach(function (option) {
    if (option.Status !== OFFERING_OPTION_STATUSES.REMOVED) {
      var billerRulesGroupedByType = getOptionBillerRulesGroupedByType(option);
      var optionHasStandaloneUsageBillerRule = getOptionHasUsageBillerRuleOnly(billerRulesGroupedByType);
      forEachObjIndexed(function (billerRules, billerRuleType) {
        optionsByBriType[billerRuleType].push(Object.assign({}, option, {
          showUsageIcon: !!(!optionHasStandaloneUsageBillerRule && billerRulesGroupedByType[BILLER_RULE_INSTANCE_TYPE.USAGE])
        }));
      }, billerRulesGroupedByType);
      if (optionHasStandaloneUsageBillerRule) {
        option.BillerTypeAmounts = uniqBy(function (BillerTypeAmounts) {
          BillerTypeAmounts.type;
        }, option.BillerTypeAmounts);
        optionsByBriType[BILLER_RULE_INSTANCE_TYPE_COMBINATIONS.STANDALONE_USAGE].push(option);
      }
    }
  });
  return optionsByBriType;
}
var initializeBriOptionsObject = function initializeBriOptionsObject() {
  var optionsByBriType = Object.keys(BILLER_RULE_INSTANCE_TYPE).reduce(function (accumulator, type) {
    return Object.assign(accumulator, _defineProperty({}, BILLER_RULE_INSTANCE_TYPE[type], []));
  }, {});
  optionsByBriType[BILLER_RULE_INSTANCE_TYPE_COMBINATIONS.STANDALONE_USAGE] = [];
  return optionsByBriType;
};
export function hasPendingChange(offer) {
  if (!offer || !offer.Options) {
    return false;
  }
  return offer.Options.some(function (e) {
    return e.Status === OFFERING_OPTION_STATUSES.PENDING_ACTIVE || e.Status === OFFERING_OPTION_STATUSES.PENDING_REMOVED;
  });
}
var bothPending = function bothPending(statuses) {
  var active = statuses.some(function (status) {
    return status === OFFERING_OPTION_STATUSES.PENDING_ACTIVE;
  });
  var remove = statuses.some(function (status) {
    return status === OFFERING_OPTION_STATUSES.PENDING_REMOVED;
  });
  return active && remove;
};
export function offerOptionsStatus(offer) {
  if (!offer || !offer.Options) {
    return false;
  }
  var statuses = offer.Options.map(function (e) {
    return e.Status;
  });
  return statuses.length > 1 && bothPending(statuses) ? OFFERING_OPTION_STATUSES.PENDING_ACTIVE : Math.max.apply(Math, statuses);
}
export function isPaymentInstrumentChangeable(offer) {
  if (!offer || !offer.Options) {
    return false;
  }
  return offer.Options.some(function (o) {
    return o.OffCycleDetail || false;
  });
}